import React, { useEffect } from "react";
import PaymentHistoryBody from "../components/profile/paymentHistory";
export default function PaymentHistory() {
  useEffect(() => {
    document.title = "Payment History | FameWheels";
  }, []);
  return (
    <>
      <PaymentHistoryBody />
    </>
  );
}
